export class Matrix {



	static init(matrix, row, col) {
		for (let r = 0; r < row; r++) {
			matrix[r] = []
			for (let c = 0; c < col; c++) {
				matrix[r][c] = Math.random() - 0.5
			}
		}
	}


	static multiply(matrix, vector, result) {
		for (let i = 0; i < matrix.length; i++) {
			let sum = 0
			for (let j = 0; j < matrix[0].length; j++) {
				sum += matrix[i][j] * vector[j]
			}
			result[i] = sum
		}
	}


	static multiplyR(v, m, r) {
		for (let i = 0; i < m[0].length; i++) {
			r[i] = 0.0;
			for (let j = 0; j < m.length; j++) {
				r[i] += m[j][i] * v[j];
			}
		}
	}


}


export function sigmoid(x) {
	return 1 / (1 + Math.exp(-x));
}


export function sigmoidDerivate(activation) {
	return activation * (1 - activation)
}


export function mseDerivate(activation, target) {
	return (activation - target) * sigmoidDerivate(activation)
}


/*
	static mult(m1, m2, result) {
		for (let row = 0; row < m1.length; row++) {
			for (let col = 0; col < m2[0].length; col++) {
				let sum = 0
				for (let i = 0; i < m2.length; i++) {
					sum += m1[row][i] * m2[i][col]
				}
				result[row][col] = sum
			}
		}
	}
*/